import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HomeMyServices } from '@core/domain/model/home/home-my-services.model';
import { HomeMyInvoices } from '@core/domain/model/home/home-my-invoices.model';

export const homeActions = createActionGroup({
  source: 'Home',
  events: {
    fetchMyServices: emptyProps(),
    setMyServices: props<{ services: HomeMyServices }>(),
    fetchMyInvoices: emptyProps(),
    setMyInvoices: props<{ invoices: HomeMyInvoices }>(),
  },
});
